import React, { useState } from "react";
import EditAdjustmentModal from "./EditAdjustmentModal2";
import { useTheme } from "../hooks/useTheme";
import { calculateTheAdjustmentPriceByType } from "../../utils/summaryCalculation";

type AdjsutmentListProps = {
    adjustmentData: any[];
    extraValue: any[];
    summaryData: any;
    isCompletedOrCancelled: boolean
    refreshTheSummary: () => void;
    reservationId: number;
    setPleaseWait: (value: boolean) => void;
}

const AdjustmentList = ({
    adjustmentData,
    extraValue,
    summaryData,
    isCompletedOrCancelled,
    refreshTheSummary,
    reservationId,
    setPleaseWait
}: AdjsutmentListProps) => {
    const { themeStyles } = useTheme();
    const [editAdjustmentIsOpen, setEditAdjustmentIsOpen] = useState<boolean>(false);
    const [modalData, setModalData] = useState<any>({});

    const renderTheAmountOrPrice = (reservationAdditionalChargeId: number, value: number) => {
        const selectedAdjustmentAdditionalCharge = extraValue?.find((item: any) =>
            item?.additionalCharges?.some((data: any) => data?.reservationAdditionalId === reservationAdditionalChargeId)
        )?.additionalCharges?.find((data: any) => data?.reservationAdditionalId === reservationAdditionalChargeId);

        if (selectedAdjustmentAdditionalCharge) {
            let totalDays = 0;
            totalDays = summaryData ? (summaryData?.totalMonths * 30) + (summaryData?.totalWeeks * 7) + summaryData?.totalDays + (summaryData?.totalHours > 0 ? 1 : 0) : 0;

            const basePrice = calculateTheAdjustmentPriceByType(
                selectedAdjustmentAdditionalCharge,
                summaryData?.totalBasePriceBeforeDiscount,
                totalDays
            );         

            if (selectedAdjustmentAdditionalCharge?.chargeType === "Amount") {
                return `$${parseFloat(basePrice?.toString())?.toFixed(2)}`;
            } else {
                return `${parseFloat(basePrice?.toString())?.toFixed(2)}%`;
            }
        } else {
            return parseFloat(value?.toString())?.toFixed(2);
        }
    }


    return (
        <div className="mt-2 w-full">
            <table className="min-w-full">
                <tbody className="text-left">
                    <tr className={`border-b ${themeStyles.main.borderColor}`}>
                        <th className={`w-[5%] text-[12px] font-semibold mb-2 pr-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>#</th>
                        <th className={`w-[30%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Charge or Adjustment</th>
                        <th className={`w-[20%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Quantity</th>
                        <th className={`w-[10%] text-[12px] font-semibold mb-2 pl-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Amount/Percentage</th>
                        <th className={`w-[35%] text-[12px] font-semibold mb-2 pl-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Comments</th>
                    </tr>

                    {
                        adjustmentData?.map((item: any, index: number) => {
                            return (
                                <tr key={index} className={`border-b ${themeStyles.main.borderColor}`}>
                                    <td className="pr-[0.25rem] py-2 w-[5%]">
                                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.id}</span>
                                    </td>

                                    <td className="px-[0.25rem] py-2 w-[30%]">
                                        <span
                                            className={`text-xs font-medium underline text-[#0000ff] cursor-pointer`}
                                            onClick={() => {
                                                setModalData(item);
                                                setEditAdjustmentIsOpen(true);
                                            }}
                                        >
                                            {item?.additionalChargeName}
                                        </span>
                                    </td>

                                    <td className="px-[0.25rem] py-2 w-[20%]">
                                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.quantity}</span>
                                    </td>

                                    <td className="pl-[0.25rem] w-[10%]">
                                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{renderTheAmountOrPrice(item?.id, item?.basePrice)}</span>
                                    </td>

                                    <td className="pl-[0.25rem] w-[35%]">
                                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>{item?.comment}</span>
                                    </td>
                                </tr>
                            );
                        })
                    }
                </tbody>
            </table>

            <EditAdjustmentModal
                editAdjustmentIsOpen={editAdjustmentIsOpen}
                setEditAdjustmentIsOpen={setEditAdjustmentIsOpen}
                modalData={modalData}
                setModalData={setModalData}
                extraValue={extraValue}
                summaryData={summaryData}
                isCompletedOrCancelled={isCompletedOrCancelled}
                refreshTheSummary={refreshTheSummary}
                reservationId={reservationId}
                setPleaseWait={setPleaseWait}
            />
        </div>
    )
}

export default AdjustmentList;